import { Tooltip, TooltipContent, TooltipTrigger } from '@bpinternal/ui-kit-next'
import { type ReactNode } from 'react'

type Props = {
  timestamp: Date
  direction?: string
  children: ReactNode
}

const formatTimestamp = (date: Date) => {
  const dateStr = new Intl.DateTimeFormat(undefined, { dateStyle: 'medium' }).format(date)
  const timeStr = new Intl.DateTimeFormat(undefined, { timeStyle: 'short' }).format(date)
  return `Sent on ${dateStr} at ${timeStr}`
}

export const MessageTimestampTooltip = ({ timestamp, direction, children }: Props) => {
  if (Number.isNaN(timestamp.getTime())) {
    return children
  }

  const align = direction === 'outgoing' ? 'end' : 'start'

  return (
    <Tooltip delayDuration={1000}>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent align={align}>{formatTimestamp(timestamp)}</TooltipContent>
    </Tooltip>
  )
}
